/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import {
  formatCurrency,
  formatPercent,
  formatRelativeTime,
  unmaskCurrency,
  assetProfited
} from "../../../helpers";
import moment from "moment";

const ShowProfit = () => (
  <span className="profit">
    <svg viewBox="0 0 31.5 31.5">
      <path
        className="st0"
        d="M5,12.3c-0.4,0.4-0.4,1.1,0,1.6c0.4,0.4,1.1,0.4,1.6,0l8-8v21.6c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1V5.8l8,8c0.4,0.4,1.2,0.4,1.6,0c0.4-0.4,0.4-1.2,0-1.6l-10-10c-0.4-0.4-1.1-0.4-1.6,0L5,12.3z"
      />
    </svg>
  </span>
);

const ShowLoss = () => (
  <span className="loss">
    <svg
      viewBox="0 0 31.5 31.5"
      style={{ enableBackground: "new 0 0 31.5 31.5" }}
    >
      <path
        className="st0"
        d="M26.4,18.2c0.4-0.4,0.4-1.1,0-1.6c-0.4-0.4-1.1-0.4-1.6,0l-8,8V3c0-0.6-0.5-1.1-1.1-1.1S14.6,2.4,14.6,3v21.7l-8-8c-0.4-0.4-1.2-0.4-1.6,0s-0.4,1.2,0,1.6l10,10c0.4,0.4,1.1,0.4,1.6,0L26.4,18.2z"
      />
    </svg>
  </span>
);
export default class AssetKPIs extends PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired
  };
  renderKPIs = asset => {
    const {
      investmentEndDate,
      stats: { investmentInfo }
    } = asset;

    let maturityDate = moment(new Date(investmentEndDate));
    let daysToMaturity = 0;

    if (maturityDate.isValid()) {
      daysToMaturity = maturityDate.diff(moment(), "days");
    }

    switch (asset.assetType) {
      case "note":
        return (
          <tbody>
            <tr>
              <th className="pl-4">Cash Flow</th>
              <th>Investment</th>
              <th>Interest</th>
              <th>Maturity</th>
            </tr>
            <tr>
              <td className="pl-4">
                {formatCurrency.format(asset.stats.cashflow.currMonth)}
                {assetProfited(asset) ? (
                  <ShowProfit />
                ) : (
                  <ShowLoss />
                )}{" "}
              </td>
              <td>
                {formatCurrency.format(
                  unmaskCurrency(
                    investmentInfo && investmentInfo.meta.investment_amount
                  )
                )}
              </td>
              <td>
                {formatPercent.format(
                  investmentInfo && investmentInfo.meta.interest / 100
                )}
              </td>

              <td>{formatRelativeTime.format(daysToMaturity, "days")}</td>
            </tr>
          </tbody>
        );
      case "syndication":
        return (
          <tbody>
            <tr>
              <th className="pl-4">Cash Flow (YTD)</th>
              <th>Investment</th>
              <th>Annual CoC</th>
              <th>Maturity</th>
            </tr>
            <tr>
              <td className="pl-4">
                {formatCurrency.format(asset.stats.cummCashflow)}
              </td>
              <td>
                {formatCurrency.format(
                  unmaskCurrency(
                    investmentInfo && investmentInfo.meta.investment_amount
                  )
                )}
              </td>
              <td>
                {formatPercent.format(
                  investmentInfo && investmentInfo.meta.annual_coc / 100
                )}
              </td>
              <td>{formatRelativeTime.format(daysToMaturity, "days")}</td>
            </tr>
          </tbody>
        );
      default:
        return (
          <tbody>
            <tr>
              <th className="pl-4">Cash Flow</th>
              <th>NOI</th>
              <th>Cash Flow (Total)</th>
              <th>Equity</th>
            </tr>
            <tr>
              <td className="pl-4">
                {" "}
                {formatCurrency.format(asset.stats.cashflow.currMonth)}
                {assetProfited(asset) ? (
                  <ShowProfit />
                ) : (
                  <ShowLoss />
                )}
              </td>
              <td>
                {formatCurrency.format(asset.stats.noi.currMonth)}
                {asset.stats.noi.currMonth >= asset.stats.noi.prevMonth ? (
                  <ShowProfit />
                ) : (
                  <ShowLoss />
                )}
              </td>
              <td>{formatCurrency.format(asset.stats.cummCashflow)}</td>
              <td>{formatCurrency.format(asset.stats.equity)}</td>
            </tr>
          </tbody>
        );
    }
  };
  render() {
    const { asset } = this.props;

    return (
      <div className="assets_card_info">
        <table className="table">{this.renderKPIs(asset)}</table>
      </div>
    );
  }
}
